/** Pulls a displayable string out of an axios/FastAPI error, whatever shape it arrives in. */
export function apiError(err, fallback = "Something went wrong") {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string" && detail) return detail;
  if (Array.isArray(detail)) {
    const msg = detail.map((d) => d?.msg).filter(Boolean).join(" ");
    if (msg) return msg;
  }
  if (typeof detail?.msg === "string") return detail.msg;
  return fallback;
}
